var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.56096 26.1606C1.49066 26.3526 1.48091 26.5616 1.53304 26.7593C1.58517 26.9571 1.69667 27.1341 1.85251 27.2665C2.00835 27.3989 2.20103 27.4803 2.4046 27.4998C2.60816 27.5194 2.81281 27.476 2.99096 27.3756L23.991 15.3643C24.1473 15.2779 24.2775 15.1511 24.3683 14.9972C24.459 14.8433 24.5068 14.668 24.5068 14.4893C24.5068 14.3107 24.459 14.1353 24.3683 13.9815C24.2775 13.8276 24.1473 13.7008 23.991 13.6143L2.99096 1.63309C2.81335 1.53375 2.60965 1.49097 2.40708 1.51046C2.20451 1.52994 2.0127 1.61077 1.85728 1.74214C1.70186 1.87352 1.59022 2.04919 1.53727 2.24569C1.48432 2.44219 1.49259 2.65016 1.56096 2.84184L5.49971 14.5006L1.56096 26.1606Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconSvg);
export default __webpack_public_path__ + "static/media/SendIconSVG.9f54ffe7c5ad3ee2fd9b14edf429cba0.svg";
export { ForwardRef as ReactComponent };